import { FirestoreQueryBuilder } from '../../../../lib/gcp/builder/firestore-query.builder';
import { IRepository } from '../../../../utility/repository/repository';
import { Observable } from 'rxjs';
import { Organization } from '../entity';
import { OrganizationId } from '../value';

export abstract class IOrganizationRepository extends IRepository<OrganizationId, Organization> {
  abstract selectAll(builder: FirestoreQueryBuilder<Organization>): Observable<Organization>;
}
